import axios from "axios"

const API = axios.create({
 baseURL: "https://www.agminfra18.com/api",

 //baseURL: "http://localhost:3002/api",
});

export default API;